export default "__VITE_ASSET__HPxN0Iz1__"